import React from "react"
import glamorous from "glamorous"
import { Link } from "react-router-dom"

import Actions from "./Actions"
import Navigation from "./Navigation"

import style from "utils/style"

const Header = props => (
  <Wrapper>
    <Link to="/">
      <Logo src="/logo-shadow-min.png" />
    </Link>
    <Navigation />
    <Actions />
  </Wrapper>
)

const Wrapper = glamorous.div({
  zIndex: "1000",
  display: "flex",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  flexDirection: "row",
  flexWrap: "wrap",
  backgroundColor: style.colors.veryLightGray,
  "@media(min-width: 750px)": {
    alignItems: "center",
  },
  "@media(max-width: 750px)": {
    boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
  },
})

const Logo = glamorous.img({
  width: 110,
  height: 80,
  marginLeft: 10,
  marginTop: 3,
  "@media(max-width: 750px)": {
    position: "absolute",
  },
})

export default Header



// WEBPACK FOOTER //
// ./src/containers/Header/index.js